import { IconDownload, IconInfoSquareRounded } from '@tabler/icons-react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { Link } from 'src/components/Link/Link'
import { Text } from 'src/components/Text/Text'

import styles from './ProductAccordion.module.scss'

interface GearExtendedElementInfoProps {
  gearExtended: { labels: { label: string }[]; values: string[] }
}

export const GearExtendedElementInfo = ({ gearExtended }: GearExtendedElementInfoProps) => {
  const { t } = useTranslation()

  const { labels, values } = gearExtended

  const data = labels.map(({ label }, index) => ({
    label,
    value: values[index],
  }))

  return (
    <>
      <div className={clsx(styles.dataContainer, styles.extended)}>
        {data.map((d) => (
          <div className={styles.dataRow} key={d.label}>
            <div className={clsx(styles.dataLabel, styles.extended)}>{d.label}</div>
            <div className={clsx(styles.dataValue, styles.extended)}>
              <IconDownload size={25} stroke={1.6} />
              <Link href={d.value} target="_blank" aria-label={`${t('common.download')} - ${t('common.newTab')}`}>
                {t('common.download')}
              </Link>
            </div>
          </div>
        ))}
      </div>
      <Text variant="p">{t('pdp.accordion.gear.gearExtended.text')}</Text>
      <div className={styles.linkContainer}>
        <div className={styles.linkRow}>
          <IconInfoSquareRounded stroke={1.6} />
          <Link
            href={t('pdp.accordion.gear.gearExtended.help.link')}
            target="_blank"
            aria-label={`${t('pdp.accordion.gear.gearExtended.help.text')} - ${t('common.newTab')}`}
          >
            {t('pdp.accordion.gear.gearExtended.help.text')}
          </Link>
        </div>
      </div>
    </>
  )
}
